import { Button, Grid, Typography } from '@mui/material'
import { FormModal } from 'components/common/formModal'

export interface ConfirmationModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  callback: () => void
  message: string | JSX.Element
  title: string
  color?:
    | 'inherit'
    | 'primary'
    | 'info'
    | 'warning'
    | 'success'
    | 'error'
    | 'secondary'
}

export const ConfirmationModal = ({
  open,
  setOpen,
  callback,
  message,
  title,
  color = 'primary',
}: ConfirmationModalProps): JSX.Element => {
  const handleConfirm = (): void => {
    callback()
    setOpen(false)
  }

  return (
    <FormModal
      open={open}
      onClose={() => setOpen(false)}
      title={title}
      color={color}
      width={480}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1" align="center">
            {message}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Button
            fullWidth
            variant="outlined"
            color={color}
            size="large"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            fullWidth
            variant="contained"
            color={color}
            size="large"
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </Grid>
      </Grid>
    </FormModal>
  )
}
